import Image from "next/image"
import { useUserStore } from "@/stores/useUserStore";
import { useEffect, useState } from "react";
import { MenuItemProps } from "../Utils/constants";


type menuItem = {
  image: string;
  name: string;
  action: string;
}

const menu_list: Array<menuItem> = [
  {
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/user-account-icon.png",
    name: "Account Details",
    action: "account_details",
  },
  {
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/user-home-icon.png",
    name: "Address",
    action: "address",
  },
  {
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/user-purchase-icon.png",
    name: "My Purchase",
    action: "my_purchase",
  },
  {
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/user-voucher-icon.png",
    name: "My Voucher",
    action: "my_voucher",
  },
  {
    image: process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/user-logout-icon.png",
    name: "Logout",
    action: "logout",
  },
]

const Menu = (props: MenuItemProps) => {
  const { userInfo, getUser } = useUserStore();
  const [userData, setUserData] = useState(getUser());

  useEffect(() => {
    setUserData(getUser());
  }, [userInfo, getUser])

  return (
    <div className="w-full md:p-8 md:rounded-lg md:shadow-[0_5px_25px_-5px_rgb(0,0,0,0.1)] bg-[#FCFCF8]">
      <div className="flex items-center space-x-2">
        <Image
          src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/account-circle.svg"}
          alt="account circle icon"
          width={38}
          height={38}
          quality={100}
        />
        <p className="text-base text-[#2C3E2F] font-dmsans font-bold">{userData.name}</p>
      </div>
      <div className="border-t border-[#C6C6C6] border-solid w-full my-4"></div>
      {menu_list.map((item, index) => (
        <div key={index}>
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => props.setSelected(item.action)}
          >
            <div className="flex items-center space-x-4" key={index}>
              <Image
                src={item.image}
                alt={item.name + " icon"}
                width={20}
                height={20}
                quality={100}
              />
              <p className={`text-base text-[#2C3E2F] font-dmsans ${props.selected === item.action ? "font-bold" : "font-normal"}`}>{item.name}</p>
            </div>
            <Image
              src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/icon/arrow-right.svg"}
              alt="right arrow icon"
              width={24}
              height={24}
              quality={100}
            />
          </div>
          {index < menu_list.length - 1 && (
            <div className="border-t border-[#C6C6C6] border-solid w-full my-4"></div>
          )}
        </div>
      ))}
    </div>
  )
}

export default Menu
